import styles from 'styles/views/widgets/Confirm.css';
import React, { Component, PropTypes } from 'react';
import Button from './Button';

export default class Confirm extends Component {
  static propTypes = {
    cancelLabel: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    confirmLabel: PropTypes.string,
    onClick: PropTypes.func,
    style: PropTypes.object,
    title: PropTypes.string
  };

  constructor (...args) {
    super(...args);
    this.state = {
      eventHighlighted: null
    };
  };

  handleClick = (confirmed) => () => {
    return this.props.onClick(confirmed);
  }

  render () {
    return (
      <div className={styles.container}>
        <div className={styles.outer}>
          <div className={styles.header}>
            <div className={styles.title}>
              {this.props.title}
            </div>
          </div>
          <div className={styles.content}>
            <div className={styles.message}>
              {this.props.children}
            </div>
          </div>
          <div className={styles.footer}>
            <div className={styles.message}>
              <Button
                className={`${styles.button} ${styles.cancel}`}
                onClick={this.handleClick(false)}>
                {this.props.cancelLabel}
              </Button>
              <Button
                className={`${styles.button} ${styles.confirm}`}
                onClick={this.handleClick(true)}>
                {this.props.confirmLabel}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/widgets/Confirm.js
 **/